import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import { PrivateRoute } from '../../../auth'
import { DEFAULT_ROLES } from '../../../../common/core/_consts'
import { ExternalTransactionList } from './components/externalTransaction-list/ExternalTransactionList'
import { ExternalTransactionDetails } from './components/externalTransaction-detail/ExternalTransactionDetails'

const ExternalTransactionsPage: React.FC = () => {    
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    index
                    element={
                        <PrivateRoute roles={DEFAULT_ROLES} >
                            <ExternalTransactionList />
                        </PrivateRoute>
                    }
                />
                <Route
                    path=':id'
                    element={
                        <PrivateRoute roles={DEFAULT_ROLES} >
                            <ExternalTransactionDetails />
                        </PrivateRoute>
                    }
                />
            </Route>
        </Routes>
    )
}

export default ExternalTransactionsPage